// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3BW7h","button_primary":"Button_button_primary__22c2e","button_secondary":"Button_button_secondary__3ODMi","btn_disable":"Button_btn_disable__2y76w"};